module.exports = __webpack_public_path__ + "media/pop_hi.5f184fa9.wav";